import React, {useEffect, useState} from "react"
import { PageContent, CustomBreadcrumb } from "components/Common";

import { ModuleIds } from "constant";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import CategorySurveys from "./CategorySurvey";
import SiteService from 'services/Site';

const RESOURCE = ModuleIds.Category;

const CategoryContainer = ({ t }) => {
    const titleTag = t("Khớp mã CategorySurvey");
    const [sites, setSites] = useState([]);

    useEffect(() => {
        const getData = async () => {
            const res = await SiteService.getLabelAndValueSite({
                page: 1,
                size: 1000,
                search: "",
            });
            setSites(res.data)
        }
        getData();
    }, []);

    return (
        <PageContent title={t(titleTag)}>
            {/* Page Title */}
            < CustomBreadcrumb
                breadcrumbItem={titleTag}
                resource={RESOURCE}               
                icon={<i className='bx bx-link'></i>}
            />
            {/* Page Body */}
            <CategorySurveys sites={sites} />          
        </PageContent >
    )
}

CategoryContainer.propTypes = {
    t: PropTypes.any,
}

export default withTranslation(["mapCategoryPage"])(CategoryContainer)